import { Typography, Box, Container, Card, CardContent } from '@mui/material';
import { Language } from '@mui/icons-material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import heromob from '../../assets/slide0.png';
import bg1 from '../../assets/bg1.png';
import Navbar from '../Navbar/Navbar';

const theme = createTheme({
  palette: {
    primary: {
      main: '#6366f1',
    },
    secondary: {
      main: '#ffffff',
    },
  },
  typography: {
    fontFamily: 'Inter, system-ui, sans-serif',
  },
});

export default function HomeslayLanding() {
  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #a855f7 100%)',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `url(${bg1})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            opacity: 0.3,
            zIndex: 0,
          }}
        />
        <Navbar />

        {/* Hero Section */}
        <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 1 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: { xs: 4, lg: 8 },
              minHeight: '70vh',
              flexDirection: { xs: 'column', lg: 'row' },
            }}
          >
            {/* Left Content */}
            <Box sx={{ flex: 1, width: '100%' }}>
              <Card
                sx={{
                  backgroundColor: 'rgba(255, 255, 255, 0.9)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '16px',
                  p: { xs: 3, sm: 4 },
                  maxWidth: { xs: '100%', lg: '600px' },
                  boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  ml: { lg: 4, xl: 6 },
                }}
              >
                <CardContent sx={{ p: 0 }}>
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: { xs: '2rem', sm: '2.5rem', md: '3.5rem' },
                      fontWeight: 700,
                      color: '#6366f1',
                      lineHeight: 1.1,
                      mb: 3,
                      letterSpacing: '-1px',
                    }}
                  >
                    A GREAT APP MAKES YOUR LIFE BETTER
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: { xs: '1rem', sm: '1.1rem' },
                      color: '#666',
                      lineHeight: 1.6,
                      mb: 4,
                    }}
                  >
                    From hotels to rentals to hostels—managing your guests' experiences has never
                    been easier.
                  </Typography>

                  <Box sx={{ mt: 4 }}>
                    <Typography
                      variant="h5"
                      sx={{
                        fontSize: { xs: '1.2rem', sm: '1.5rem' },
                        fontWeight: 600,
                        color: '#333',
                        mb: 2,
                      }}
                    >
                      ACCESS IT NOW
                    </Typography>

                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                        flexDirection: { xs: 'column', sm: 'row' },
                        alignItems: { xs: 'flex-start', sm: 'center' },
                      }}
                    >
                      <Language sx={{ color: '#6366f1', fontSize: 24 }} />
                      <Typography
                        variant="body1"
                        sx={{
                          fontSize: { xs: '0.9rem', sm: '1rem' },
                          fontWeight: 600,
                          color: '#333',
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px',
                        }}
                      >
                        WORKS ON ANY DEVICE — NO DOWNLOAD NEEDED!
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Box>

            {/* Right Image */}
            <Box
              sx={{
                flex: 1,
                display: 'flex',
                justifyContent: 'center',
                mt: { xs: 4, lg: 0 },
                mb: '10px',
              }}
            >
              <Box
                component="img"
                src={heromob}
                alt="Mobile App Interface"
                sx={{
                  width: { xs: '250px', sm: '380px', lg: '400px' },
                  height: 'auto',
                  objectFit: 'contain',
                  maxHeight: { xs: '500px', sm: '560px', lg: '600px' },
                }}
              />
            </Box>
          </Box>
        </Container>
      </Box>
    </ThemeProvider>
  );
}
